

export const currency = new Intl.NumberFormat('en-US', 
                        {style: 'currency',currency: 'USD',maximumFractionDigits: 0,  minimumFractionDigits: 0,    

                    });

export  const onlyTwoDigits = new Intl.NumberFormat('en-US', {
                       minimumFractionDigits: 0,      
                       maximumFractionDigits: 2,
                    });

export  const notDecimals = new Intl.NumberFormat('en-US', {
                       minimumFractionDigits: 0,      
                       maximumFractionDigits: 2,
                    });

export function onlyTwoDigitsV2(number) {
   
    return onlyTwoDigits.format(number)
}
export  function formatterMetrico(valor,formato)
    {
        switch(formato)
        {
            case '$':
                return currency.format(valor)
            case '%':
                return onlyTwoDigits.format(valor) + formato
            default:
                return onlyTwoDigits.format(valor)
        }
    }



 export  function  formatMinCurrency(number)
 {

        let notDecimals = new Intl.NumberFormat('en-US', {
                       minimumFractionDigits: 0,      
                       maximumFractionDigits: 0,
                    });
        let unitlist = ["","K","M","G"];
         let sign = Math.sign(number);
         let unit = 0;
        if (Number.isFinite(number)&& !isNaN(number))
        {
         while(Math.abs(number) > 1000)
         { 
           unit = unit + 1; 
           number = Math.floor(Math.abs(number) / 100)/10;
         }

         if (unit === 0) 
         {
           return  notDecimals.format(sign*number)
         }else
         {
            return sign*number + unitlist[unit]
         }

          
        }else
        {
            return 0
        }
        
         
}